export default function Test() {
  return (
    <div className="bg-white text-black text-center p-10 rounded-xl shadow-md w-full">
      <p>🧪 Jika kotak ini terlihat rapi & tengah, berarti fix!</p>
    </div>
  );
}
